/** Path do Route dos KPIs de Cross Sell */
export const CROSS_SELL_KPIS_PATH_ROUTE = 'cross-sell';
